import React from 'react';
import { Input } from '../ui/input';

// Delivery / service address that drives sales tax (never substituted by billing)
export const DeliveryAddressFields = ({ value, onChange, testId }) => {
  const v = value || {};
  const set = (k) => (e) => onChange({ ...v, [k]: e.target.value });
  return (
    <div data-testid={testId}>
      <h3 className="text-sm font-semibold text-neutral-700 mb-1">Delivery / Service Address</h3>
      <p className="text-xs text-neutral-500 mb-3">Sales tax is calculated from this address. Leave blank and tax stays "to be confirmed".</p>
      <div className="grid grid-cols-6 sm:grid-cols-4 gap-4">
        <div className="col-span-6 sm:col-span-4"><Input value={v.street || ''} onChange={set('street')} placeholder="Street address" data-testid={`${testId}-street`} /></div>
        <div className="col-span-6 sm:col-span-2"><Input value={v.city || ''} onChange={set('city')} placeholder="City" data-testid={`${testId}-city`} /></div>
        <div className="col-span-2 sm:col-span-1"><Input value={v.state || ''} onChange={set('state')} placeholder="State" data-testid={`${testId}-state`} /></div>
        <div className="col-span-4 sm:col-span-1"><Input value={v.zip || ''} onChange={set('zip')} placeholder="ZIP" inputMode="numeric" autoComplete="postal-code" data-testid={`${testId}-zip`} /></div>
      </div>
    </div>
  );
};
